import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetRequestsList = () => 
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}StepIn/GetRequestsList`
	});

export const DeleteRequest = (userId, name) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}StepIn/DeleteRequest`,
		data: { name, userId }, // Passa o nome do request a ser excluído
	});

export const UpdateRequest = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}StepIn/Update`,
		data: dto, // Passa o objecto do request para ser actualizado
	});

export const CreateRequest = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}StepIn/Upload`,
		data: dto, /// Passa o objecto do request para ser criado
	});